// jshint module: true

import randomHash from './../../assets/scripts/modules/random-hash';
import findParentByClassName from './../../assets/scripts/modules/find-parent-by-classname';
import insertScript from './../../assets/scripts/modules/insert-script';

const component = 'video';
const selector = `.${component}`;

let elements = [];

function prepareVimeo(iframeId, videoId, iframe, element) {

  if (!iframe) {
    return;
  }

  const onPlayerReady = () => {
    let timeout;

    if (!window.$f) {
      return;
    }

    const player = window.$f(iframe);

    if (!player) {
      return;
    }

    const parent = findParentByClassName(iframe, 'video') || iframe.parentNode.parentNode;

    if (parent.getAttribute('data-autoplay') !== null) {
      player.api('setVolume', 0);
      player.api('play');

      // Extra call to mute in Safari -- dirty
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), iframe.getAttribute('src').split(';')[0]);
      } catch(e) {
        //
      }

      // And another few extra calls to mute in Safari -- dirtier
      const muteVideo = () => player.api('setVolume', 0);

      [ 100, 200, 500, 1000 ].map((i) => {

        window.clearTimeout(timeout);
        timeout = window.setTimeout(muteVideo, i);

      });

      // WHY DONT YOU JUST MUTE SAFARI 😤
    }

    iframe.classList.remove('is-hidden');
    parent.classList.add('is-playing');

    window.addEventListener('page-change', () => {
      player.api('stop');
    }, false);

  };

  iframe.addEventListener('load', onPlayerReady);

  iframe.setAttribute('src', `//player.vimeo.com/video/${videoId}?byline=0&amp;title=0&amp;portrait=0&amp;loop=0&amp;autoplay=1&amp;autopause=1&amp;color=fff&amp;api=1&amp;player_id=${iframeId}`);
  element.parentNode.replaceChild(iframe, element);

}

function prepareYouTube(iframeId, videoId) {

  if (!iframeId || !videoId) {
    return;
  }

  const onPlayerReady = (event) => {
    const instance = event.target;

    if (!instance) {
      return;
    }

    const iframe = instance.getIframe();

    if (!iframe) {
      return;
    }

    const parent = findParentByClassName(iframe, 'video') || iframe.parentNode.parentNode;

    iframe.classList.add('iframe');
    instance.setPlaybackQuality('hd1080');

    if (parent.getAttribute('data-autoplay') !== null) {
      instance.mute();
    }

    instance.playVideo();

    iframe.classList.remove('is-hidden');
    parent.classList.add('is-playing');

    window.addEventListener('page-change', () => {
      instance.stop();
    }, false);

  };

  let player;
  let interval;

  window.onYouTubeIframeAPIReady = function() {
    window.youtubeScriptLoaded = true;
  };

  interval = window.setInterval(() => {

    if (!window.youtubeScriptLoaded || !window.YT || !window.YT.Player) {
      return;
    }

    player = new window.YT.Player(iframeId, { width: 640, height: 360, videoId: videoId, playerVars: { autoplay: 1, hd: 1, showinfo: 0, modestbranding: 1, 'iv_load_policy': 3, rel: 0, playlist: '' }, events: { onReady: onPlayerReady }});
    window.clearInterval(interval);

  }, 250);

}

function loadIframe(event) {
  const iframeId = 'player-' + randomHash();

  if (!event) {
    return;
  }

  const element = event.target;
  const parent = element.parentNode;
  const id = element.getAttribute('data-id');
  const type = element.getAttribute('data-type');

  event.preventDefault();

  if (!id) {
    return false;
  }

  if (type === 'vimeo') {
    insertScript('vimeo-api-script', 'https://f.vimeocdn.com/js/froogaloop2.min.js', () => {

      const iframe = document.createElement('iframe');

      iframe.id = iframeId;
      iframe.className = 'iframe is-hidden';

      prepareVimeo(iframeId, id, iframe, element);

    });
  } else {
    insertScript('youtube-api-script', 'https://youtube.com/iframe_api', () => {

      const div = document.createElement('div');

      div.id = iframeId;
      div.className = 'iframe is-hidden';
      parent.replaceChild(div, element);

      prepareYouTube(iframeId, id);

    });
  }

}

function init() {

  elements = document.querySelectorAll(selector);

  if (!elements.length) {
    return;
  }

  [...elements].forEach((element) => {
    const hitTarget = element.querySelector('.hit-target');

    if (hitTarget) {
      hitTarget.addEventListener('click', loadIframe);
    }

    if (element.getAttribute('data-autoplay') !== null) {
      let timeout;

      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => hitTarget.click(), 50); // Arbitrary timeout to make sure the wrapper styling is painted first.
    }

  });

}

window.addEventListener('init-content-load', init);
window.addEventListener(`reinit-${component}`, init);



// WEBPACK FOOTER //
// ./website/components/video/video.js